
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { FlowTemplateService } from "../services/flow-template.service";
import { FlowTemplate } from "../../common/models/flow.dto";
import { genId } from "../../core/services/genId";
import { LoaderService } from "../../common/services/loader.service";

@Injectable()

export class FlowTemplateResolver  {

  constructor(public readonly service: FlowTemplateService, public loader: LoaderService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): FlowTemplate | Observable<FlowTemplate> | Promise<FlowTemplate> {

    this.loader.toggleLoader(true);

    let id = route.params.id;
    const majorVersion = route.params.majorVersion;
    const minorVersion = route.params.minorVersion;

    if (id === "new") {
      id = genId();
      this.service.cacheStub(id);
    };

    const template = (isNaN(majorVersion) || isNaN(minorVersion))
      ? this.service.get(id)
      : this.service.getByVersion(id, majorVersion, minorVersion, false);

      return template.pipe(tap((data) => {
          this.loader.toggleLoader(false);
      }));
  }


}
